import React, { useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from '../../Hooks';
import {
  AnalyticsInsightsType,
  setAnalyticsInsights
} from '../../Services/AnalyticsInsights';

export const AnalyticsInsights = (): React.ReactElement<{}> => {
  const history = useHistory();
  const query = useQuery();

  useEffect(() => {
    try {
      const type: AnalyticsInsightsType = query.get(
        'type'
      ) as AnalyticsInsightsType;
      const id: string | undefined = query.get('id') as string;

      setAnalyticsInsights({ type: type, id: id });

      history.push(`/app/analytics/${type}${id ? `/${id}` : ''}`);
    } catch (e) {
      console.error('AnalyticsInsights::onMount', e);
      history.push('/error');
    }
  }, [query, history]);

  return <Fragment></Fragment>;
};
